import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../routes/Module12";
import LayoutActividad from "../../components/LayoutActividad";
import Sidebar from "./Sidebar";
import Imagen from "../../images/modulo12/mercado.png";
import GuiaDocente from "../../components/GuiaDocente";
import AudioPlayer from "../../audioPlayer/AudioPlayer";
import Audio from "../../audios/modulo12/Inicio.mp3";

const Modulo1 = () => {
  const nextUnity = modulo12.content[0];
  const nextActivity = nextUnity.activities[0];

  const pages = {
    titleNext: `${nextActivity.name}`,
    linkNext: `${modulo12.url}/${nextUnity.path}/${nextActivity.path}`,
  };
  const crumbs = [
    {
      title: `${modulo12.title} > Inicio `,
      url: "/" + modulo12.url,
    },
  ];
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title}`,
    name: modulo12.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div>
        <h1 className="my-5">{modulo12.title}</h1>
        <AudioPlayer track={Audio} />
      </div>

      <div className="">
        <img src={Imagen} className="img-fluid" alt="..." />
      </div>
      <div className="mt-4">
        <p>
          En la Parte 1 de este nivel conoceremos la diversidad de personas que
          componen el Perú. Para ello, consideraremos las diferencias entre el
          campo y la ciudad, la posición que ocupamos en la sociedad y la
          desigualdad entre hombres y mujeres. A partir de estos temas,
          desarrollaremos habilidades para convivir, deliberar y participar en
          contextos diversos.
        </p>
        <ul>
          <li>
            Identificamos a las diversas personas y grupos sociales que forman
            parte del Perú.
          </li>
          <li>Conocemos procesos históricos que explican dicha diversidad.</li>
          <li>
            Compartimos nuestras experiencias personales a partir de lo
            aprendido.
          </li>
          <li>
            Reflexionamos sobre la importancia de la diversidad y nos
            reconocemos como parte de ella.
          </li>
        </ul>
      </div>
      <div className="unit-options my-5">
        <a href={"https://ciudadania.pe/actividades-interactivas/" + pages.linkNext}>
          <button className={`btn btn-${modulo12.color} me-2`}>
            Empezar actividades <FontAwesomeIcon icon={faMap} />
          </button>
        </a>
      </div>
      <GuiaDocente>
        <ul>
          <li>Lean la pregunta y observen la ilustración.</li>
          <li>
            Pregunte y recoja las respuestas:
            <br />
            <i>
              “A partir de lo observado, ¿de qué creen que tratará esta parte?”. Resalte que se pregunta por quiénes somos los
              peruanos, es decir, nuestras características como una comunidad
              que comparte el mismo país pero que es muy diversa. En la
              ilustración se muestra un mercado. Pida que hagan una descripción
              general del lugar. Resalte que en el mercado se puede observar a
              varias personas interactuando. Pida que se fijen en las
              características de estas personas y resalte algunas diferencias
              entre estas (por ejemplo: edad, rasgos físicos, etc.)”.
            </i>
          </li>

          <li>
            Ahora, lea el texto que explica de qué tratará esta unidad y lo que
            se busca con las actividades a realizar.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Modulo1;
